import React from "react";
import { Switch, Route } from "react-router-dom";
import Mdvrdownloadfile from "./Index";

export default () => (
  <Switch>
    <Route exact path="/mdvrdownloadfile" component={Mdvrdownloadfile} />
  </Switch>
);
